import { useGetFacetAlertsQuery } from '@/redux/api/client/facetAlerts';
import { IFacetAlert } from '@/@types/client-api';

export interface IAlertPlacement {
  alert: IFacetAlert | null;
  targetGroupTypeId: string | null;
  targetFacetValue: string | null;
}

const useFacetAlerts = () => {
  const { data } = useGetFacetAlertsQuery();

  return data || [];
};

export default useFacetAlerts;
